import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    showModal: false,
    activeCourse: '',
  },
  reducers: {
    openModal(state, action) {
      state.showModal = true;
      state.activeCourse = action.payload;
    },
    closeModal(state) {
      state.showModal = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
